'use strict';

angular.module('licensure.services')
    .factory('LicenseRequestProcess', ['$http', '$q', 'FBResponses', 'Triggers', function ($http, $q, FBResponses, Triggers) {
        return {
            updateProcess: function (license_request_id, status, note) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licenserequestprocessstatuses/processchange/';

                $http({
                    method: method,
                    url: url,
                    data: {
                        licenseRequestID: license_request_id,
                        statusID: status.status_id,
                        processID: status.process_id,
                        note: note
                    }
                })
                    .then(function (response) {
                    var promises = [];

                    // fire triggers if need be
                    if (status.manual_trigger_id != null && status.manual_trigger_name != null && status.manual_trigger_name != "") {
                        promises.push(Triggers.fire({
                            name: status.manual_trigger_name,
                            licenseRequestID: license_request_id,
                            triggerID: status.manual_trigger_id
                        }));
                    }
                    if (status.link_trigger_id != null && status.link_trigger_name != null && status.link_trigger_name != "") {
                        promises.push(Triggers.fire({
                            name: status.link_trigger_name,
                            licenseRequestID: license_request_id,
                            triggerID: status.link_trigger_id
                        }));
                    }

                    // resolve
                    $q.all(promises).then(function () {
                        d.resolve(status);
                    }).catch(function (response) {
                        // handle error
                    });
                })
                .catch(function (response) {
                    // handle error
                })

                return d.promise;
            }
            
        }
    }])
;